const getKPIOptions = "GET_KPI_OPTIONS";
const getUserKPI = "GET_USER_KPI";
const setUserKPI = "SET_USER_KPI";
const removeUserKPI = "DELETE_USER_KPI";

export const initialState = {
  options: [],
  data: [],
  loading: true
};

//
// Base API calls
//
async function apiGet(url, getState){
  let objectReturned;
  await fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }).then((response) => {
    if (response.status === 200) {
      return response.text();
    } else {
      objectReturned = [];
    }
  }).then( (data) =>{
      // This is to handle Blank Body text that fetch hates
      objectReturned = data ? JSON.parse(data) : [];
    }
  ).catch((error) =>{
    throw error;
  });
  return objectReturned;
}

async function apiPutPost(url, method, body, getState){
  let objectReturned;
  await fetch(url, {
    method: method,
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }),
    body: JSON.stringify(body)
  }).then((response) => {
    if (response.status === 200) {
      return response.text();
    } else {
      objectReturned = [];
    }
  }).then( (data) =>{
    // This is to handle Blank Body text that fetch hates
      objectReturned = data ? JSON.parse(data) : [];
    }
  ).catch((error) =>{
      throw error;
    });
  return objectReturned;
}

async function apiDelete(url, getState){
  let objectReturned;
  await fetch(url, {
    method: 'DELETE',
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }).then((response) => {
    if (response.status === 200) {
      return response.text();
    } else {
      objectReturned = [];
    }
  }).then( (data) =>{
      // This is to handle Blank Body text that fetch hates
      objectReturned = data ? JSON.parse(data) : [];
    }
  ).catch((error) =>{
    throw error;
  });
  return objectReturned;
}


//
// Actions
//
export const actionCreators = {
  getOptions: () => async (dispatch, getState) => {
    const url = `api/kpi/`;
    
    let options = await apiGet(url, getState);

    dispatch({type: getKPIOptions, options})
  },
  getUserKPI: () => async (dispatch, getState) => {
    const url = `api/kpi/user`;
    
    let data = await apiGet(url, getState);
    
    dispatch({type: getUserKPI, data})
  },
  setUserKPI: (kpi_id) => async (dispatch, getState) => {
    const url = `api/kpi/${kpi_id}`;
    const data = getState().kpi.data;
    const options = getState().kpi.options;
    let data_copy = JSON.parse(JSON.stringify(data));
    let options_copy = JSON.parse(JSON.stringify(options));
    let doesnt_exist = true;
    
    await apiPutPost(url, "POST", '', getState);
    
    // Query user KPI to add to user's data
    let new_item = await apiGet(url, getState);
    
    // Get single KPI back, and add to 'Data' in the store
    for (let index in data_copy){
      if (data_copy.hasOwnProperty(index)){
        if (data_copy[index].key === new_item.type){
          data_copy[index].value.push(new_item);
          doesnt_exist = false;
          break;
        }
      }
    }
    // If we never found a kpi type for our kpi in the object, create one
    if (doesnt_exist){
      data_copy.push({
        key: new_item.type,
        value: [new_item]
      });
    } 
    
    // Update the unselected items to no longer display the newly selected kpi
    for (let index in options_copy){
      if (options_copy.hasOwnProperty(index)){
        for (let i = 0; i < options_copy[index].value.length; i++){
          if(options_copy[index].value[i].id === kpi_id){
            options_copy[index].value.splice(i, 1);
            break;
          }
        }
        // If there are no more kpi in the kpi type, remove it for UI purposes
        if (options_copy[index].value.length === 0){
          options_copy.splice(index, 1);
        }
      } 
    } 
    
    dispatch({type: setUserKPI, data_copy, options_copy})
  },
  removeUserKPI: (kpi_id) => async (dispatch, getState) => {
    const url = `api/kpi/${kpi_id}`;
    const data = getState().kpi.data;
    const options = getState().kpi.options;
    let data_copy = JSON.parse(JSON.stringify(data));
    let options_copy = JSON.parse(JSON.stringify(options));
    let doesnt_exist = true;
    
    await apiDelete(url, getState);
    
    let kpi;
    // remove the kpi_id from the user's list
    for (let index in data_copy){
      if (data_copy.hasOwnProperty(index)){
        for (let i = 0; i < data_copy[index].value.length; i++){
          if(data_copy[index].value[i].id === kpi_id){
            kpi = data_copy[index].value[i];
            data_copy[index].value.splice(i, 1);
            break;
          }
        }
        // If there are no more kpi in the kpi type, remove it for UI purposes
        if (data_copy[index].value.length === 0){
          data_copy.splice(index, 1);
        } 
      }
    }
    
    // add the kpi_id back to the kpi list
    for (let index in options_copy){
      if (options_copy.hasOwnProperty(index)){
        if (options_copy[index].key === kpi.type){
          options_copy[index].value.push(kpi);
          doesnt_exist = false;
          break;
        }
      }
    }
    // If we never found a kpi type for our kpi in the object, create one
    if (doesnt_exist){
      options_copy.push({
        key: kpi.type,
        value: [kpi]
      });
    }

    dispatch({type: removeUserKPI, data_copy, options_copy})
  }
};


//
// Reducer
//
export const reducer = (state, action) => {
  state = state || initialState;
  
  if (action.type === getKPIOptions){
    return {
      ...state,
      options: action.options
    }
  } 
  if (action.type === getUserKPI){
    return {
      ...state,
      data: action.data
    }
  }
  if (action.type === setUserKPI){
    return {
      ...state,
      data: action.data_copy,
      options: action.options_copy
    }
  }
  if (action.type === removeUserKPI){
    return {
      ...state,
      data: action.data_copy,
      options: action.options_copy
    }
  }
  
  return state;
};